import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';

import OriginatorFilterActive from '../grid-ctx/originator-filter-active';
import { GridLeftPanelProps } from '../grid-types';
import { GridLeftPanelEADItem } from './grid-left-panel-ead-item';
import { GridLeftPanelItem as DefaultGridLeftPanelItem } from './grid-left-panel-item';
import { GridLeftPanelLoadMore } from './grid-left-panel-load-more';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridLeftPanelRoot: {
      backgroundColor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
      height: 'calc(100vh - 80px)',
      position: 'sticky',
      top: 80,
      overflow: 'auto',
    },
    gridTitle: {
      color: 'white',
      fontWeight: 'bold',
      fontSize: 18,
      height: 60,
      lineHeight: '60px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      zIndex: 1000,
    },
    originatorWrapper: {
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontWeight: 'bold',
      fontSize: 16,
      padding: '16px',
    },
    originatorLabel: {
      padding: '0 8px',
      fontSize: 14,
      lineHeight: '14px',
    },
    originatorRemove: {},

    // GridLeftPanelItemStyles
    link: {
      color: theme.palette.grey[300],
    },
    icon: {
      fontSize: 14,
      margin: `0 ${theme.spacing(1)}px`,
    },
    listItem: {
      fontSize: 13,
      lineHeight: '1.5em',
      fontWeight: 500,
      color: theme.palette.grey[300],
    },
    listItemActive: {
      fontSize: 13,
      lineHeight: '1.5em',
      fontWeight: 500,
      color: theme.palette.primary.light,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    subTitle: {
      fontSize: 12,
      lineHeight: 'normal',
      textTransform: 'uppercase',
      fontWeight: 600,
      letterSpacing: '1px',
      color: theme.palette.grey[300],
    },
  })
);

export type GridLeftPanelItemClasses = ReturnType<typeof useStyles>;

export function GridLeftPanel(props: GridLeftPanelProps) {
  const classes = useStyles();
  const {
    rootArchivalAid,
    items = [],
    count = 0,
    fetchMore,
    gridConfig = [],
    hierarchyPath = [],
    GridLeftPanelItem = DefaultGridLeftPanelItem,
    leftPanelItemProps = {},
    //params = {},
    removeParams,
    archivalAidLevel,
  } = props;

  // const [originator, setOriginator] = useState<Originator | undefined>(
  //   undefined
  // );

  const [gridEntityConfig] = gridConfig;
  const { title, getId = (value) => value.id } = gridEntityConfig;

  // const originatorId = params?.filters?.find(({ field }) =>
  //   field?.includes('originator')
  // )?.value as string | undefined;

  // useEffect(() => {
  //   if (!!originatorId) {
  //     const getData = async () => {
  //       const newData = await getOriginatorDetail(originatorId);
  //       setOriginator(newData);
  //     };
  //     getData();
  //   } else {
  //     setOriginator(undefined);
  //   }
  // }, [originatorId]);

  return (
    <List
      className={classes.gridLeftPanelRoot}
      component="nav"
      dense={true}
      subheader={
        <ListSubheader component="div" className={classes.gridTitle}>
          {title}
        </ListSubheader>
      }
    >
      <OriginatorFilterActive removeParams={removeParams} />

      {items.map((item) => (
        <GridLeftPanelItem
          classes={classes}
          key={getId(item)}
          item={item}
          level={0}
          gridConfig={gridConfig}
          rootArchivalAid={rootArchivalAid}
          archivalAidLevel={archivalAidLevel}
          hierarchyPath={hierarchyPath}
          GridLeftPanelItem={
            item?.hasEadNode ? GridLeftPanelEADItem : GridLeftPanelItem
          }
          {...leftPanelItemProps}
        />
      ))}

      {items.length < count && <GridLeftPanelLoadMore fetchMore={fetchMore!} />}
    </List>
  );
}
